var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastTypeError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    stroke: "#FF6868",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9748 14.1486C11.0041 14.6934 11.4544 15.1202 12 15.1202C12.5456 15.1202 12.9959 14.6934 13.0252 14.1486L13.3986 7.1938L13.4436 5.99894C13.4744 5.18037 12.8191 4.5 12 4.5C11.1809 4.5 10.5256 5.18037 10.5564 5.99894L10.6014 7.1938L10.9748 14.1486ZM10.5405 18.124C10.5405 18.884 11.1566 19.5 11.9165 19.5H12.124C12.884 19.5 13.5 18.884 13.5 18.124C13.5 17.3641 12.884 16.7481 12.124 16.7481H11.9165C11.1566 16.7481 10.5405 17.3641 10.5405 18.124Z",
    fill: "#FF6868"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastTypeError);
export default __webpack_public_path__ + "static/media/toast_type_error.0981050949c7073a2fc04737ab0c8619.svg";
export { ForwardRef as ReactComponent };